import React, { Component, forwardRef } from 'react'
import { style } from '../../variables/Variables.jsx'
import { Grid, Row, Col, Table, FormControl, Button } from 'react-bootstrap'
import Card from '../../components/Card/Card.jsx'
import NotificationSystem from 'react-notification-system'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import 'react-day-picker/lib/style.css'
import moment from 'moment'
import 'moment/locale/pl'
import { formatDate, parseDate } from 'react-day-picker/moment'
import Select from 'react-select'
import Pagination from '../../components/Pagination/Pagination.jsx'
import { CSVLink } from 'react-csv'

moment.locale('pl')

const API_SERVER = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : '..'

const CustomDatePicker = forwardRef((props, ref) => (
  <div ref={ref} className='input-group' style={{ zIndex: 0 }}>
    <FormControl
      id={props.id}
      type='text'
      className='form-control'
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      onClick={props.onClick}
      onFocus={props.onFocus}
      onKeyUp={props.onKeyUp}
      onBlur={props.onBlur}
      style={{ height: '38px' }}
    />
    <span className='input-group-addon btnIco' onClick={props.onClearFix}>x</span>
  </div>
))

class CronJobLogs extends Component {
  constructor (props) {
    super(props)
    this.notificationSystem = React.createRef()
    this.sendNotification = this.sendNotification.bind(this)
    this.search = this.search.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      count: 0,
      page: 1,
      loader: true,
      cronLogs: [],
      csvRecords: [],
      query: {
        message: '',
        status: '',
        dateCall: ''
      }
    }
  }

  UNSAFE_componentWillMount () {
    this.timer = null
    this.delay = 600
    this.limit = 20
  }

  componentDidMount () {
    this.search(1)
  }

  sendNotification (icon, msg, lvl) {
    this.notificationSystem.current.addNotification({
      title: (<span data-notify='icon' className={icon} />),
      message: (
        <div>{msg}</div>
      ),
      level: lvl,
      position: 'tr'
    })
  }

  search (page = 1, searchParam = null, limit = true, cb = () => {}) {
    const state = this.state
    const query = { limit: this.limit, skip: (page - 1 < 0) ? 0 : (page - 1) * this.limit, where: { and: [] }, order: 'dateCall DESC' }
    if (!limit) {
      delete query.limit
      delete query.skip
    }
    state.page = page
    state.query = searchParam ? { ...state.query, ...searchParam } : state.query
    let key
    for (key in state.query) {
      if (state.query[key] && state.query[key].length) {
        switch (key) {
          case 'dateCall': {
            const date = new Date(state.query[key])
            query.where.and.push({ dateCall: { gte: date.toISOString() } })
            date.setDate(date.getDate() + 1)
            query.where.and.push({ dateCall: { lt: date.toISOString() } })
            break
          }
          case 'message':
          case 'name':
            query.where.and.push({ [key]: { like: state.query[key] } })
            break
          default:
            query.where.and.push({ [key]: { eq: state.query[key] } })
        }
      }
    }
    if (!query.where.and.length) {
      delete query.where
    }
    fetch(`${API_SERVER}/db/api/cron_logs?filter=${JSON.stringify(query)}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'GET'
    })
      .then(res => {
        state.count = res.headers.get('X-Total-Count')
        return res
      })
      .then(res => res.json())
      .then(response => {
        if (!limit) {
          state.csvRecords = response
          state.loader = false
        } else {
          state.cronLogs = response
          state.loader = false
        }
        this.setState(state, () => cb())
      })
      .catch((err) => {
        console.log(err)
        state.loader = false
        this.setState(state, () => cb())
      })
  }

  handleChange (e) {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.setState({ loader: true }, () => {
        this.search(1, { [e.name]: e.value })
      })
    }, this.delay)
  }

  render () {
    return (
      <div className='content'>
        <NotificationSystem ref={this.notificationSystem} style={style} />
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title='Lista logów cronów'
                category={
                  <ul className='ownLegend'>
                    <li><span className='' /> nieznany</li>
                    <li><span className='bg-success' /> sukces</li>
                    <li><span className='bg-warning' /> błąd</li>
                  </ul>
                }
                content={
                  <div>
                    <Button
                      className='btn btn-xs btn-danger' onClick={e => {
                        e.preventDefault()
                        this.search(1, null, false, () => {
                          document.getElementById('downloadReportsCsvButton').click()
                        })
                      }}
                    >Pobierz jako csv
                    </Button>
                    <CSVLink
                      id='downloadReportsCsvButton'
                      style={{ display: 'none' }}
                      data={this.state.csvRecords}
                      filename={`wyslane_raporty_${moment().format('YYYY-MM-DD-hh-mm-ss')}.csv`}
                      className='btn btn-xs btn-danger'
                      separator=';'
                      target='_blank'
                    />
                    <Table hover className='mb-0'>
                      <thead>
                        <tr>
                          <td style={{ maxWidth: '250px' }}>Nazwa</td>
                          <td style={{ maxWidth: '130px' }}>Status</td>
                          <td style={{ maxWidth: '160px' }}>Data wywołania</td>
                          <td style={{ maxWidth: '160px' }}>Data zakończenia</td>
                          <td style={{ maxWidth: '140px' }}>Czas wykonania</td>
                          <td style={{ maxWidth: '450px' }}>Informacja</td>
                        </tr>
                        <tr>
                          <td style={{ maxWidth: '250px' }}>
                            <FormControl
                              type='text'
                              name='name'
                              defaultValue={this.state.query.name}
                              onChange={e => this.handleChange({ name: e.target.name, value: e.target.value })}
                            />
                          </td>
                          <td style={{ maxWidth: '130px' }}>
                            <Select
                              isClearable
                              options={[
                                { value: 'unknown', label: 'Nieznany' },
                                { value: 'success', label: 'Sukces' },
                                { value: 'error', label: 'Błąd' }
                              ]}
                              placeholder=''
                              onChange={e => this.handleChange({ name: 'status', value: (e && e.value) ? e.value : '' })}
                            />
                          </td>
                          <td style={{ maxWidth: '160px' }}>
                            <DayPickerInput
                              inputProps={{
                                id: 'dateCall',
                                name: 'dateCall'
                              }}
                              component={forwardRef((props, ref) => <CustomDatePicker
                                ref={ref} {...props} onClearFix={() => {
                                  this.handleChange({ name: 'dateCall', value: '' })
                                  document.getElementById('dateCall').value = ''
                                }}
                                                                    />
                              )}
                              formatDate={formatDate}
                              parseDate={parseDate}
                              format='YYYY-MM-DD'
                              placeholder='YYYY-MM-DD'
                              dayPickerProps={{
                                locale: 'pl',
                                firstDayOfWeek: 1
                              }}
                              onDayChange={date => {
                                this.handleChange({ name: 'dateCall', value: date ? moment(date).format('YYYY-MM-DD') : '' })
                              }}
                              style={{ display: 'block' }}
                            />
                          </td>
                          <td style={{ maxWidth: '160px' }} />
                          <td style={{ maxWidth: '140px' }} />
                          <td style={{ maxWidth: '450px' }} />
                        </tr>
                      </thead>
                      <tbody>
                        {
                        (this.state.cronLogs.length > 0)
                          ? this.state.cronLogs.map((prop, key) => {
                            let duration = ''
                            if (prop.dateCall && prop.dateEnd) {
                              const start = moment(prop.dateCall)
                              const end = moment(prop.dateEnd)
                              const diff = moment.duration(end.diff(start))
                              const hours = Math.floor(diff.asHours())
                              const minutes = diff.minutes()
                              const seconds = diff.seconds()
                              duration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
                            }
                            return (
                              <tr key={`${prop.id}${key}`} className={`${(prop.status === 'unknown') ? '' : (prop.status === 'success') ? 'bg-success' : 'bg-warning'}`}>
                                <td style={{ maxWidth: '250px' }}>{prop.name}</td>
                                <td style={{ maxWidth: '130px' }}>{prop.status}</td>
                                <td style={{ maxWidth: '160px' }}>{moment(prop.dateCall).format('YYYY-MM-DD HH:mm:ss')}</td>
                                <td style={{ maxWidth: '160px' }}>{prop.dateEnd ? moment(prop.dateEnd).format('YYYY-MM-DD HH:mm:ss') : ''}</td>
                                <td style={{ maxWidth: '140px' }}>{duration}</td>
                                <td style={{ maxWidth: '450px' }}>{prop.message}</td>
                              </tr>
                            )
                          })
                          : (
                            <tr className='bg-warning'>
                              <td colSpan='6'>Brak wyników</td>
                            </tr>
                            )
                      }
                      </tbody>
                    </Table>
                    <Pagination page={this.state.page} count={this.state.count} limit={this.limit} search={this.search} />
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        <div id='own-preloader' className={`${this.state.loader === true ? 'show' : ''}`}>
          <div id='own-loader' />
        </div>
      </div>
    )
  }
}

export default CronJobLogs
